import React, { useState } from "react";

import Toast from 'react-bootstrap/Toast';

import icon from "@app/images/picto/toast-notif.svg";

/**
 * Display a Toast notif
 * 
 * @returns 
 */
export default function ToastNotif({toast}) {     
    const [show, setShow] = useState(true);

    if (!toast)
        return;

    return (
        <Toast className="custom-toast" onClose={() => setShow(false)} show={show} delay={6000} autohide>
            <Toast.Header>
                <span className="me-auto">{toast.title}</span>
            </Toast.Header>
            <Toast.Body>{toast.description}</Toast.Body>
        </Toast>
    )
}
